export * from "./routeConstants";
export * from "./path";
export * from "./reducerConstants";
export const isIncortaLinkVisible =
  window.env.REACT_APP_IS_INCORTA_LINK_VISIBLE || false;
export const isMarketingActivitiesLinkVisible =
  window.env.REACT_APP_MARKETING_ACTIVITIES_LINK || false;
